import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://porticosystems.com';

/** Organization + WebSite schema - used on homepage */
export const OrganizationSchema = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Portico Systems",
      "url": BASE_URL,
      "logo": `${BASE_URL}/Assets/logos/portico-logo.svg`,
      "description": "Commercial flooring solutions for businesses. Entrance matting, carpet tiles, luxury vinyl, rubber flooring, and custom logo mats.",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "US"
      },
      "sameAs": []
    })}</script>
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Portico Systems",
      "url": BASE_URL,
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${BASE_URL}/products?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    })}</script>
  </Helmet>
);

/** BreadcrumbList schema */
export const BreadcrumbSchema = ({ items }) => {
  if (!items || items.length === 0) return null;
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": item.name,
      ...(item.url ? { "item": `${BASE_URL}${item.url}` } : {})
    }))
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

/** Product schema for product detail pages */
export const ProductSchema = ({ product }) => {
  if (!product) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name + (product.variant ? ` - ${product.variant}` : ''),
    "description": product.description || '',
    "image": product.heroImage ? `${BASE_URL}${product.heroImage}` : undefined,
    "brand": {
      "@type": "Brand",
      "name": "Portico Systems"
    },
    "category": product.category || product.type || '',
    "url": `${BASE_URL}/products/${product.slug}`,
    ...(product.material ? { "material": product.material } : {}),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

/** LocalBusiness schema for Contact page */
export const LocalBusinessSchema = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Portico Systems",
      "url": BASE_URL,
      "logo": `${BASE_URL}/Assets/logos/portico-logo.svg`,
      "description": "Commercial flooring solutions provider specializing in entrance matting, carpet tiles, luxury vinyl, rubber flooring, and custom logo mats.",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "US"
      },
      "priceRange": "$$-$$$$"
    })}</script>
  </Helmet>
);
